
import { Suspense, useEffect } from 'react';
import { BrowserRouter, useRoutes, useLocation } from 'react-router-dom';
import routes from './router/config';
import AuthProvider from './components/auth/AuthProvider';

function AppRoutes() {
  const location = useLocation();
  const routing = useRoutes(routes);

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return routing;
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AuthProvider>
        <Suspense fallback={
          <div className="min-h-screen flex items-center justify-center bg-white">
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-r from-yellow-400 to-yellow-500 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-car-line text-3xl text-black"></i>
              </div>
              <div className="text-lg font-semibold text-gray-900 mb-2">Loading...</div>
              <div className="text-sm text-gray-600">Georgia Dealer License Course</div>
            </div>
          </div>
        }>
          <AppRoutes />
        </Suspense>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
